const PARIS_TIME_ZONE = 'Europe/Paris';
const BUSINESS_DAYS_UNTIL_DELIVERY = 3;

function parisDateParts() {
  const parts = new Intl.DateTimeFormat('fr-FR', {
    timeZone: PARIS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return [Number(values.year), Number(values.month), Number(values.day)];
}

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k + 70) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day, 12));
}

function holidayKeys(year) {
  const easter = easterSunday(year);
  const movable = [1, 39, 50].map((offset) => {
    const date = new Date(easter);
    date.setUTCDate(date.getUTCDate() + offset);
    return `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
  });

  return new Set([
    '1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25',
    ...movable,
  ]);
}

function estimateDeliveryDate() {
  const [year, month, day] = parisDateParts();
  const date = new Date(Date.UTC(year, month - 1, day, 12));
  let remaining = BUSINESS_DAYS_UNTIL_DELIVERY;

  while (remaining > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    const weekday = date.getUTCDay();
    const key = `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
    if (weekday !== 0 && weekday !== 6 && !holidayKeys(date.getUTCFullYear()).has(key)) {
      remaining -= 1;
    }
  }

  return { date, orderYear: year };
}

class BentivanaDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.dateNode = this.querySelector('[data-delivery-date]');
    if (!this.dateNode || this.timer) return;

    this.onVisibilityChange = () => {
      if (!document.hidden) this.renderDate();
    };
    this.renderDate();
    this.timer = window.setInterval(() => this.renderDate(), 60_000);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    this.timer = null;
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  renderDate() {
    const { date, orderYear } = estimateDeliveryDate();
    const label = new Intl.DateTimeFormat(document.documentElement.lang.toLowerCase().startsWith('en') ? 'en-GB' : document.documentElement.lang.toLowerCase().startsWith('de') ? 'de-DE' : 'fr-FR', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: date.getUTCFullYear() === orderYear ? undefined : 'numeric',
    }).format(date);

    this.dateNode.textContent = label.charAt(0).toUpperCase() + label.slice(1);
    this.dateNode.dateTime = date.toISOString().slice(0, 10);
  }
}

if (!customElements.get('bentivana-delivery-estimate')) {
  customElements.define('bentivana-delivery-estimate', BentivanaDeliveryEstimate);
}
